
<h2 mat-dialog-title>{{'interfaces.add_mapping' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >

      <form [formGroup]="mappingForm">
        @if (type=='media') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'interfaces.key' | translate}}</mat-label>
            <input formControlName="key" type="text" matInput>
          </mat-form-field>
        }

        @if (type=='ids') {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'interfaces.key' | translate}}</mat-label>
            <input formControlName="type" type="text" matInput>
          </mat-form-field>
        }

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'interfaces.path' | translate}}</mat-label>
          <input formControlName="path" type="text" matInput>
        </mat-form-field>
      </form>

    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="dialogCancel();" > {{'cancel' | translate}} </button>
  <button mat-button class="orange-button" (click)="dialogSave();"  >{{'save' | translate}}</button>
</mat-dialog-actions>
